enum DisplayNames {
  AspectRatio = 'AspectRatio',
  Box = 'Box',
  Center = 'Center',
  Circle = 'Circle',
  Container = 'Container',
  Divider = 'Divider',
  Flex = 'Flex',
  Grid = 'Grid',
  GridItem = 'GridItem',
  SimpleGrid = 'SimpleGrid',
  Spacer = 'Spacer',
  Square = 'Square',
  Stack = 'Stack',
  HStack = 'HStack',
  VStack = 'VStack',
  Wrap = 'Wrap',
  WrapItem = 'WrapItem'
}

export default DisplayNames;
